"use client";
/**
 * AskPageClient — client shell that reads session ID from URL and renders ChatWindow.
 * Track C2.
 */
import { ChatWindow } from "./ChatWindow";

interface AskPageClientProps {
  sessionId?: string;
}

export function AskPageClient({ sessionId }: AskPageClientProps) {
  return <ChatWindow sessionId={sessionId} />;
}
